import { useEffect } from 'react'

import { toastEventListener } from '@space-lib-events/toast'

export const useToastEventListener = () => {
  useEffect(() => {
    const unsubscribeToastEvent = toastEventListener()

    return () => {
      unsubscribeToastEvent()
    }
  }, [])
}
